<template>
  <div class="setting-advanced-knowledge module-item-style">
	  <div class="add-edit-wrap editor-dialog">
		  <el-form :model="problemForm">
		    <el-form-item label="主问法">
		      <el-input v-model="problemForm.standard" placeholder="请输入主问法" autocomplete="off"></el-input>
		    </el-form-item>
		    <el-form-item label="分类">
		      <el-select v-model="problemForm.name" placeholder="请选择分类">
		        <el-option
		            v-for="item in categoryList"
		            :key="item.classId"
		            :label="item.name"
		            :value="item.name"></el-option>
		      </el-select>
		    </el-form-item>
			<div class="wl-btn" @click="showDialog = true">添加关联问题</div>
			<div class="module-item-tips">关联问题(最多可添加10个关联问题，点击<span style="color: #409EFF;">{{buttonText}}</span>按钮生效)</div>
			<div class="common-problem-table">
				<el-table
						size="small"
						:data="SelectionData"
						:header-cell-style="{background:'#f2f2f2'}"
						style="width: 100%;border: 1px solid #ebeef5;margin-top: 5px;">
					<el-table-column
						type="index"
						label="序号"
						width="50">
					</el-table-column>
					<el-table-column
						show-overflow-tooltip
						prop="problem"
						label="问题">
					</el-table-column>
					<el-table-column align="center" width="100" label="操作">
						<template slot-scope="scope">
							<el-button
								type="text"
								size="mini"
								@click="handleRemove(scope.row)">移除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		    <el-form-item label="回答" style="z-index: 9;">
		      <div v-if="showEditor" id="editor" class="zIndex9" placeholder="请输入回答" ref="editor"></div>
		    </el-form-item>
		  </el-form>
		  <div class="dialog-footer">
			<span class="wl-btn wl-btn-normal" @click="goback">取消</span>
			<span class="wl-btn" @click="submitProblemForm">{{buttonText}}</span>
		  </div>
	  </div>
	  <!--    关联问题-dialog-->
	  <el-dialog
		  width="800px"
	      title="关联问题"
	      class="editor-dialog"
	      :visible.sync="showDialog">
	    <related-problems ref="related" :SelectionData="SelectionData"></related-problems>
	    <!-- <div slot="footer" class="dialog-footer">
	      <el-button @click="showDialog = false">取 消</el-button>
	      <el-button type="primary" @click="selectRelatedProblems">确 定</el-button>
	    </div> -->
	  </el-dialog>
  </div>
</template>

<script>
  import E from 'wangeditor'
  import relatedProblems from "./components/related-problems.vue"
  export default {
	components:{
		relatedProblems
	},
    data() {
      return {
        accept: 'image/gif, image/jpeg, image/png, image/jpg',
        fileaccept:'',
		showEditor: true,
        editor: null,
		categoryList:[],
        problemForm: {
          id:'',
          name: '',
          standard: '',
          external: '',
		  relatedProblems:[],
        },
        answerOnlyPic: false,
		knowledgeCookie:{},
		buttonText:"确定添加",
		showDialog:false,
		SelectionData:[],
      }
    },
    created() {
		this.knowledgeObj = localStorage.getItem("knowledgeObj")?JSON.parse(localStorage.getItem("knowledgeObj")):{}
		if(this.knowledgeObj&&this.knowledgeObj.id){
			this.problemForm.id = this.knowledgeObj.id
			this.problemForm.name = this.knowledgeObj.name
			this.problemForm.standard = this.knowledgeObj.standard
			this.SelectionData = this.knowledgeObj.relatedProblems
			console.log(this.SelectionData)
		}
		this.getClassList()
		
    },
    mounted() {
		if(this.knowledgeObj&&this.knowledgeObj.answer){
			this.buttonText = "确定编辑"
			this.initEditor(this.knowledgeObj.answer)
		}else{
			this.initEditor()
		}
    },
    computed: {
		
	},
    methods: {
	  getClassList(){
	    this.$http.getClassListAPI({
	      pageNum: 1,
	      pageSize:500
	    }).then( res => {
	      if(res.status == 1){
	        this.categoryList = res.data.list	  
	      }
	    })
	  },
      initEditor(data) {
        let editor = new E(this.$refs.editor)
        this.editor = editor
        editor.customConfig.menus = [
          'head',
          'bold',
          'italic',
          'underline',
          'list',
          'justify',
          'image',
          'link',
        ]
        let _that = this
        editor.customConfig.linkImgCallback = function (url) {
          _that.answerOnlyPic = true
        }
        editor.customConfig.customUploadImg = function (files, insert) {
          let img = files[0]
          let type = img.type
          let size = img.size
          if (_that.accept.indexOf(type) == -1) {
            _that.$message({
              showClose: true,
              message: '图片格式不正确，请选择我们支持的图片格式 .gif, .jpeg, .png, .jpg',
              type: 'error',
              duration: 3 * 1000
            })
            return false
          }
          if (size > 5242880) {
            _that.$message({
              showClose: true,
              message: '请选择5M以内的图片！',
              type: 'error',
              duration: 3 * 1000
            })
            return false
          }
          let formdata = new FormData()
          formdata.set('file', img)
          _that.$http.uploadImageAPI(formdata).then(res => {
            if (res.status == 1) {
              _that.answerOnlyPic = true
              insert(res.data)
            }
          })
          // files 是 input 中选中的文件列表
          // insert 是获取图片 url 后，插入到编辑器的方法

        }
        editor.create()

        editor.txt.html(data)
      },
	  selectRelatedProblems(){
		  this.SelectionData = this.$refs.related.selectionData
		  console.log(this.SelectionData)
		  this.showDialog = false
	  },
	  handleRemove(row){
		this.SelectionData.forEach((item,index) => {
			if(item.problemId==row.problemId){
				this.SelectionData.splice(index,1)
			}
		})  
	  },
      submitProblemForm() {
        let reg = /&nbsp;/g;
        let content = this.editor.txt.text()
        this.problemForm.external = this.editor.txt.html()
        if(this.$utils.u_isEmpty(this.problemForm.standard)) {
          this.$message({
            message: '主问法不能为空',
            type: 'error',
          })
          return  false
        }
        if(this.$utils.u_isEmpty(this.problemForm.name)) {
          this.$message({
            message: '请选择分类',
            type: 'error',
          })
          return  false
        }
        if(!this.answerOnlyPic && content.replace(reg,'').trim().length == 0){
          this.$message({
            message: '回答不能为空',
            type: 'error',
          })
          return false
        }
		if(this.SelectionData.length){
			this.SelectionData.forEach((item,index) => {
				this.problemForm.relatedProblems.push(item.problemId)
			}) 
		}
        this.$http.addOrEditProblemAPI(this.problemForm).then(res => {
          if(res.status == 1){
            
            this.$message({
              message: res.msg,
              type: 'success',
            })
			this.$router.go(-1)
          }else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
      },
	  goback() {
		 this.$router.go(-1)
	  }

    },
  }
</script>

<style lang="scss">

  .setting-advanced-knowledge {
    .setting-advanced-knowledge-tips {
      border-radius: $mainBorderRadius;
      background-color: #fff2d7;
      border: 1px solid #ffdf9c;
      margin-bottom: 10px;
      line-height: 40px;
      font-size: 12px;
      color: #666;
      display: flex;
      padding: 0 19px;
      position: relative;

      .knowledge-close-btn {
        position: absolute;
        right: 0px;
        top: 50%;
        margin-top: -9px;
        cursor: pointer;
      }
    }

    .setting-advanced-tab-container {
      display: flex;
      padding: 24px 24px 17px;
      position: relative;

      li {
        margin-right: 40px;
        color: #333333;
        font-size: 12px;
        letter-spacing: 1.4px;
        cursor: pointer;
        padding-bottom: 7px;
      }

      .recharge-btn {
        position: absolute;
        right: 20px;
        top: 50%;
        margin-top: -20px;
        margin-right: 0;

        span + span {
          margin-left: 20px;
        }
		.download{
			display: inline-block;
			 font-size: 12px;
			 margin-right: 5px;
			 a{
			    color: $mainColor;
			    margin-left: 3px;
			 }
		}
      }
    }

    .setting-knowledge-container {
      margin-top: 15px;
    }

    .dialog-footer {
      text-align: center;
	  .wl-btn{
		  margin: 0 15px;
	  }
    }

    .el-form-item__label {
      float: none;
      font-weight: bold;
      color: #333;
    }

    .el-select {
      width: 100%;
    }

    .editor-dialog {
      li {
        list-style: inherit;
      }

      img {
        max-width: 300px !important;
      }

      a {
        color: $mainColor;
        text-decoration: underline;
      }
      .w-e-text-container{
        height: 230px!important;
      }
    }
	.zIndex9{
		.w-e-toolbar .w-e-menu{
			z-index: 999!important;
		}
	}
  }
</style>
